import React from 'react';
import './BeforeAfter.css';
import img4 from './../images/4.jpeg'
import img5 from './../images/5.jpeg'
const BeforeAfter = (props) => {
  return (
        <div className="project-card">
                    <div className="project-title">
      <h2 >{props.title}</h2></div>
    <div className="before-after-wrapper">

      <div className="comparison-container">
        <img
          src={props.i1}
          alt="Before"
          className="image"
        />
        <img
src={props.i2}
          alt="After"
          className="image"
        />
        <div className="label before before1">Avant</div>
        <div className="label after">Après</div>
      </div>
    </div>
    </div>
  );
};

export default BeforeAfter;
